import { Grid, Stack, Typography } from '@mui/material'
import { pick } from 'lodash'
import { WarehouseAutocompleteCard } from 'src/_modules/common/ServerAutocomplete'
import OrderBoxesCard from '../OrderBoxesCard'
import OrderDetailsCard from '../OrderDetailsCard'
import OrderItemsCard from '../OrderItemsCard'
import OrderViewDetails from './OrderViewDetails'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ROLES } from 'src/constants'

export default function OrdersDetailsTab({
  tempOrder,
  order,
  handleOrderChange,
  validationErrors,
  viewMode = false,
  isSatchelShipment
}) {
  const { t } = useTranslation()
  const { profile } = useSelector((state) => state.entities.profile)

  const shipment = order?.otoIntegration?.returnShipment ?? order?.otoIntegration?.shipment ?? null

  if (viewMode) {
    return (
      <OrderViewDetails
        tempOrder={tempOrder}
        order={order}
        isSatchelShipment={isSatchelShipment}
      />
    )
  }

  return (
    <Stack spacing={2}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <Grid item md={order?.merchantOrderNumber ? 4 : 6} sm={12} xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2 }} variant="h6" color="text.lighter" fontWeight="bold">{t("Order No.")}</Typography>
          <Typography variant="h6" fontWeight="bold">{order?.orderNumber}</Typography>
        </Grid>
        {
          profile?.role === ROLES.admin &&
          <Grid item md={order?.merchantOrderNumber ? 4 : 6} sm={12} xs={12} sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mr: 2 }} variant="h6" color="text.lighter" fontWeight="bold">{"ID"}</Typography>
            <Typography variant="h6" fontWeight="bold">{order?.id}</Typography>
          </Grid>
        }
        {
          !!shipment?.trackingNumber &&
          <Grid item md={order?.merchantOrderNumber ? 4 : 6} sm={12} xs={12} sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mr: 2 }} variant="h6" color="text.lighter" fontWeight="bold">{t("Shipment Number")}</Typography>
            <a
              href={shipment?.trackingUrl}
              target="_blank"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              <Typography variant="h6" fontWeight="bold" color="primary">{shipment?.trackingNumber}</Typography>
            </a>
          </Grid>
        }
        {
          order?.merchantOrderNumber &&
          <Grid item md={order?.merchantOrderNumber ? 4 : 6} sm={12} xs={12} sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mr: 2 }} variant="h6" color="text.lighter" fontWeight="bold">{t("Order reference number")}</Typography>
            <Typography variant="h6" fontWeight="bold">{order?.merchantOrderNumber}</Typography>
          </Grid>
        }
      </Grid>
      <OrderDetailsCard
        order={pick(tempOrder, ['amountPayable'])} //paymentMethod
        onChange={handleOrderChange}
        errors={pick(validationErrors, ['amountPayable'])}//paymentMethod
      />
      <OrderBoxesCard
        name="boxes"
        boxesData={pick(tempOrder, ['boxes', 'weight', 'packagesCount', 'calculatedWeight'])}
        otoIntegration={order?.otoIntegration}
        onChange={handleOrderChange}
        errors={validationErrors?.boxes}
      />
      <OrderItemsCard
        name="orderItems"
        orderItems={tempOrder?.orderItems ?? []}
        onChange={handleOrderChange}
        errors={validationErrors?.orderItems}
      />
      <WarehouseAutocompleteCard
        handleChange={(_, newValue) => handleOrderChange({ target: { name: "warehouse", value: newValue?.id } })}
        cardTitle={"Warehouse"}
        value={tempOrder?.warehouse}
        label={"Warehouses"}
        error={validationErrors?.warehouse}
        required
      />
    </Stack>
  )
}
